// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddressController from "./address_controller"
application.register("address", AddressController)

import BankSearchController from "./bank_search_controller"
application.register("bank-search", BankSearchController)

import BankSelectorController from "./bank_selector_controller"
application.register("bank-selector", BankSelectorController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InvoiceItemsController from "./invoice_items_controller"
application.register("invoice-items", InvoiceItemsController)

import InvoiceRejectController from "./invoice_reject_controller"
application.register("invoice-reject", InvoiceRejectController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NumberOnlyController from "./number_only_controller"
application.register("number-only", NumberOnlyController)

import OrderItemsController from "./order_items_controller"
application.register("order-items", OrderItemsController)

import PartnerSearchController from "./partner_search_controller"
application.register("partner-search", PartnerSearchController)

import PlanTiersController from "./plan_tiers_controller"
application.register("plan-tiers", PlanTiersController)

import PaymentTermsController from "./payment_terms_controller"
application.register("payment-terms", PaymentTermsController)

import PaymentTypeController from "./payment_type_controller"
application.register("payment-type", PaymentTypeController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import WorkReportItemsController from "./work_report_items_controller"
application.register("work-report-items", WorkReportItemsController)

import PdfPollController from "./pdf_poll_controller"
application.register("pdf-poll", PdfPollController)

import WorkReportSelectController from "./work_report_select_controller"
application.register("work-report-select", WorkReportSelectController)
